import React from 'react'
import Heading from '../components/Heading'
import ResponsiveTable from '../components/ResponsiveTable'
import ModuleWithLoader from '../components/ModuleWithLoader'
import DataSource from '../DataSource'
import Pagination from '../components/Pagination'
import { IS_HTML } from '../constants'
import ReactModal from './ReactModal'
import globals from '../globals'

class MessagesModule extends React.Component {
    constructor (props) {
        super(props)

        this.state = {
            isLoaded: false,
            hasError: false,
            messages: [],
            pagination: {
                current_page: 1,
                total_pages: 1
            },
            showModal: false,
            modalContent: ''
        }
    }

    componentDidMount () {
        this.getMessages()
    }

    getMessages (page = 1) {
        this.scrollToTop()
        this.setState({ messages: [] })

        DataSource.getData(`/api/getMessages/${page}`, result => {
		    if (!result.messages) {
		        result.messages = []
            }

            // Add html flag so the table knows how to handle this
            result.messages.forEach(item => {
                item[3] = IS_HTML + item[3]
            })

            this.setState({
                messages: result.messages,
                pagination: result.meta.pagination,
                isLoaded: true
            })
        }, () => {
            this.setState({ hasError: true, isLoaded: true })
        })
    }

    handleOpenModal (content) {
        this.setState({
            showModal: true,
            modalContent: content
        })
        globals.pushEvent('ViewPastMessage')
    }

    handleCloseModal () {
        this.setState({ showModal: false })
    }

    handleChangePage (event) {
        event.preventDefault()
        const page = event.target.dataset.page
        this.setState({ isLoaded: false })
        this.getMessages(page)
    }

    scrollToTop () {
        window.scrollTo(this.container.offsetLeft, this.container.offsetTop - 60)
    }

    render () {
        const headings = ['To', 'Subject', 'Date', 'View']

        return (
            <div className='messages module' ref={el => this.container = el}>
                <Heading title='My messages' />
                <ModuleWithLoader isLoaded={this.state.isLoaded} hasError={this.state.hasError} className='p-4'>
                    {this.state.messages.length > 0
                        ? <React.Fragment>
                            <ResponsiveTable
                                data={{ headings: headings, rows: this.state.messages }}
                                handleOpenModal={this.handleOpenModal.bind(this)}
                                minWidthMobile={600}
                            />
                            <Pagination
                                page={this.state.pagination.current_page}
                                pageCount={this.state.pagination.total_pages}
                                handleClick={this.handleChangePage.bind(this)}
                            />
                          </React.Fragment>
                        : <p className='text-center'>You currently have no messages to view.</p>}
                </ModuleWithLoader>

                <ReactModal showModal={this.state.showModal} handleCloseModal={this.handleCloseModal.bind(this)}>
                    <iframe src={'data:text/html,' + encodeURIComponent(this.state.modalContent)} />
                </ReactModal>
            </div>
        )
    }
}

export default MessagesModule



// WEBPACK FOOTER //
// ./resources/js/modules/MessagesModule.js